import { ArrowForwardIos } from '@lichtblick/icons';
import { styled } from '@lichtblick/styled';
import { Colors, Spacing } from '@lichtblick/theme';

export const CardContainer = styled.div<{ $isSelected: boolean }>`
  align-items: center;
  background-color: ${({ $isSelected }) => ($isSelected ? Colors.blue[20] : Colors.white)};
  display: flex;
  flex-direction: row;
  gap: ${Spacing.S};
  padding: ${Spacing.S};
  &:hover {
    background-color: ${Colors.blue[5]};
  }
`;

export const StatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.Xxs};
`;

export const Dot = styled.div<{ $color: string }>`
  background-color: ${({ $color }) => $color};
  border-radius: 50%;
  min-height: 0.8rem;
  min-width: 0.8rem;
`;

export const ArrowForwardIosIcon = styled(ArrowForwardIos)`
  font-size: 2rem;
  margin-left: auto;
  padding-right: ${Spacing.Xs};
`;
